import { render, staticRenderFns } from "./UpmsRole.vue?vue&type=template&id=478602a7&"
import script from "./UpmsRole.vue?vue&type=script&lang=js&"
export * from "./UpmsRole.vue?vue&type=script&lang=js&"
import style0 from "./UpmsRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports